import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import Layout from "../../../components/layout/Layout";
import "../../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../../assets/InnerCSS/css/styles.css";
import "../../../assets/InnerCSS/css/custom.css";
import { useHistory } from "react-router";
import IdNameModel from "../../../models/common/IdNameModel";
import modalUtils from "../../../utils/modal-utils";
import masterDataService from "../../../services/master-data-service";
import toasterUtils from "../../../utils/toaster-utils";
import CityComponent from "../../../components/admin/city/CityComponent";

const City = () => {
    const history = useHistory();
    const [country, setCountry] = useState<IdNameModel[]>([]);

    useEffect(() => {
        getCountry();
    }, [])

    const getCountry = () => {
        modalUtils.showLoader();
        masterDataService.loadCountries().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCountry(res.items);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> City
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> Cities </h4>
            </div>
            <CityComponent countryList={country} />
        </Layout>
    );
};
export default City;